import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFilters } from '../contexts/FilterContext';
import { DATE_MODES } from '../utils/dateUtils';

/**
 * MI-345: opens Movements on one account's movements, every date, as the
 * account's detail lists them. The filters go through FilterContext, as the
 * review badge's do, so they hold across the navigation.
 */
export default function useOpenAccountMovements() {
  const navigate = useNavigate();
  const { clearFilters, addFilter, setDateMode } = useFilters();

  return useCallback((accountId) => {
    clearFilters();
    setDateMode(DATE_MODES.ALL);
    addFilter({ entity: 'Movement', column: 'account_id', operator: 'in', values: [accountId] });
    navigate('/movements');
  }, [clearFilters, addFilter, setDateMode, navigate]);
}
